import React from 'react';
import { useTranslation } from 'react-i18next';

const Pagination = ({ page, totalPages, onPageChange }) => {
    const { t } = useTranslation();
    if (totalPages <= 1) return null;

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.75rem',
            marginTop: '1.5rem',
            padding: '0.75rem 0',
        }}>
            <button
                className="btn btn-secondary btn-sm"
                disabled={page <= 1}
                onClick={() => onPageChange(page - 1)}
            >
                ← {t('common.previous', 'Previous')}
            </button>
            <div style={{
                fontSize: '0.82rem',
                fontWeight: 600,
                color: 'var(--text-secondary)',
                fontFamily: 'var(--font-mono)',
                padding: '0.35rem 0.85rem',
                background: 'var(--glass-bg)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                borderRadius: 'var(--radius-sm)',
                border: '1px solid var(--glass-border)',
            }}>
                <span style={{ color: 'var(--text-primary)' }}>{page}</span>
                <span style={{ color: 'var(--text-muted)', margin: '0 0.3rem' }}>/</span>
                <span>{totalPages}</span>
            </div>
            <button
                className="btn btn-secondary btn-sm"
                disabled={page >= totalPages}
                onClick={() => onPageChange(page + 1)}
            >
                {t('common.next', 'Next')} →
            </button>
        </div>
    );
};

export default Pagination;
